import { cacheKeys } from "@constants/cache-keys";
import { isScreenshotMode } from "@constants/common";
import { useQuery } from "@tanstack/react-query";
import { fetchProductDetails, fetchProductMetadata } from "api/queries";
import { mockedProductDetails } from "./constants";
import useAppConfigIds from "./useAppConfigIds";
import { useAppStore } from "./useAppStore";
import useClerkUser from "./useClerkUser";

export const useProductDetails = () => {
	const { productId } = useAppConfigIds();
	const tenantId = useAppStore((state) => state.tenant.id);

	return useQuery({
		queryKey: [cacheKeys.productDetails, productId, tenantId],
		queryFn: async () => {
			if (isScreenshotMode) {
				return mockedProductDetails.data.productDetails;
			}
			return await fetchProductDetails({
				tenantId: tenantId,
				productId: productId,
			});
		},
		enabled: !!tenantId && !!productId,
	});
};

export const useProductMetadata = () => {
	const { productUuid } = useAppConfigIds();
	const tenantId = useAppStore((state) => state.tenant.id);

	const { userLogicalId } = useClerkUser();

	return useQuery({
		queryKey: [cacheKeys.productMetadata],
		queryFn: async () => {
			return await fetchProductMetadata({
				tenantId: tenantId,
				productId: productUuid,
				userId: userLogicalId,
			});
		},
		enabled: !!userLogicalId,
	});
};
